import { render, staticRenderFns } from "./VerDetalleModalTab.vue?vue&type=template&id=3f1d6bf2&scoped=true&"
import script from "./VerDetalleModalTab.vue?vue&type=script&lang=ts&"
export * from "./VerDetalleModalTab.vue?vue&type=script&lang=ts&"
import style0 from "./VerDetalleModalTab.vue?vue&type=style&index=0&id=3f1d6bf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1d6bf2",
  null
  
)

export default component.exports